/*
  Catering delivery fee by distance, for the catering popup.

  Uses the customer's current location (browser permission, the same one the
  catering pickup field uses) and measures it, in a straight line, to the
  closest café:
    - up to the base distance (10 mi)    -> $30 delivery fee
    - up to the maximum distance (30 mi) -> $50 delivery fee
    - beyond the maximum, or location blocked -> delivery not available,
      add to cart blocked

  The café and distance are saved on the cart line as "Delivery From" and
  "Delivery Distance"; snippets/catering-delivery-fee.liquid reads the distance
  to pick the $30 or $50 option of the Delivery Charges product.

  Settings (theme settings > Catering delivery) arrive in window.lcCateringDelivery.
  Café coordinates come from catering-locator.js (window.lcCateringCafes).
*/
(function () {
  var config = window.lcCateringDelivery || {};
  var BASE_MILES = Number(config.baseMiles) || 10;
  var MAX_MILES = Number(config.maxMiles) || 30;
  var ADDRESS = '#catering-popup input[name="properties[Delivery Address]"]';

  function milesBetween(lat1, lng1, lat2, lng2) {
    var rad = Math.PI / 180;
    var dLat = (lat2 - lat1) * rad;
    var dLng = (lng2 - lng1) * rad;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * rad) * Math.cos(lat2 * rad) *
            Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 3958.8 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function nearestCafe(lat, lng) {
    var cafes = window.lcCateringCafes || {};
    var best = null;
    Object.keys(cafes).forEach(function (name) {
      var miles = milesBetween(lat, lng, cafes[name].lat, cafes[name].lng);
      if (!best || miles < best.miles) best = { name: name, miles: miles };
    });
    return best;
  }

  // Latest result for this page: { ok, cafe, miles } or { ok: false, reason }.
  var result = null;
  var pending = null;

  function locate() {
    if (pending) return pending;
    pending = new Promise(function (resolve) {
      if (!('geolocation' in navigator)) { resolve({ ok: false, reason: 'blocked' }); return; }
      navigator.geolocation.getCurrentPosition(function (p) {
        var near = nearestCafe(p.coords.latitude, p.coords.longitude);
        if (!near) resolve({ ok: false, reason: 'blocked' });
        else if (near.miles > MAX_MILES) resolve({ ok: false, reason: 'far', cafe: near.name, miles: near.miles });
        else resolve({ ok: true, cafe: near.name, miles: near.miles });
      }, function () {
        resolve({ ok: false, reason: 'blocked' });
      }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 10 * 60 * 1000 });
    }).then(function (r) {
      result = r;
      pending = null;
      document.querySelectorAll(ADDRESS).forEach(render);
      return r;
    });
    return pending;
  }

  function hiddenField(input, name) {
    var field = input.parentNode.querySelector('input[type="hidden"][name="properties[' + name + ']"]');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'properties[' + name + ']';
      // Inside the delivery pane, so the popup's Pickup/Delivery switch disables it with the address.
      input.parentNode.appendChild(field);
    }
    field.disabled = input.disabled;
    return field;
  }

  function statusRow(input) {
    var row = input.parentNode.querySelector('.lc-delivery-status');
    if (!row) {
      row = document.createElement('div');
      row.className = 'lc-delivery-status';
      row.setAttribute('aria-live', 'polite');
      input.insertAdjacentElement('afterend', row);
    }
    return row;
  }

  function render(input) {
    var row = statusRow(input);
    var ok = result && result.ok;
    hiddenField(input, 'Delivery From').value = ok ? result.cafe : '';
    hiddenField(input, 'Delivery Distance').value = ok ? result.miles.toFixed(1) + ' mi' : '';
    row.classList.toggle('is-error', !!result && !ok);
    row.textContent = '';

    if (!result) {
      row.textContent = 'Checking delivery distance…';
      return;
    }
    if (ok) {
      var fee = result.miles <= BASE_MILES ? config.baseFee : config.farFee;
      row.textContent = 'Delivery from ' + result.cafe + ' · ' + result.miles.toFixed(1) + ' mi' +
        (fee ? ' · ' + fee + ' delivery fee' : '');
      return;
    }
    if (result.reason === 'far') {
      row.textContent = 'Sorry, we only deliver within ' + MAX_MILES + ' miles of a café. You are ' +
        result.miles.toFixed(1) + ' mi from our closest café (' + result.cafe + ').';
      return;
    }
    row.textContent = 'Allow location access in your browser so we can work out your delivery fee.';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lc-catering-locate__btn';
    btn.textContent = 'Try again';
    btn.addEventListener('click', function () {
      result = null;
      document.querySelectorAll(ADDRESS).forEach(render);
      locate();
    });
    row.appendChild(document.createTextNode(' '));
    row.appendChild(btn);
  }

  function setUp(input) {
    if (input.dataset.lcDelivery) return;
    input.dataset.lcDelivery = 'true';
    render(input);
    if (!result) locate();
  }

  function addressFor(form) {
    var input = form && form.querySelector && form.querySelector('input[name="properties[Delivery Address]"]');
    if (!input || input.disabled || !form.closest('#catering-popup')) return null;
    return input;
  }

  // Runs after the popup's own required-field check (registered earlier on the page).
  function guard(e) {
    var form = e.type === 'submit' ? e.target : (e.target.closest && e.target.closest('#catering-popup button[type="submit"], #catering-popup [name="add"]') || {}).form;
    var input = addressFor(form);
    if (!input) return;
    if (result && result.ok) {
      render(input);
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    statusRow(input).scrollIntoView({ block: 'center', behavior: 'smooth' });
    if (!result) {
      locate().then(function (r) {
        if (r.ok && form.isConnected) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  }

  document.addEventListener('submit', guard, true);
  document.addEventListener('click', guard, true);

  // The popup is injected after the page loads; the address field appears with it.
  new MutationObserver(function () {
    document.querySelectorAll(ADDRESS).forEach(setUp);
  }).observe(document.body, { childList: true, subtree: true });
  document.querySelectorAll(ADDRESS).forEach(setUp);
})();
